export default "__VITE_ASSET__DqN7fpdG__"